// src/context/ModalContext.js
import React, { createContext, useState, useContext } from 'react';

const ModalContext = createContext({
  openModal: () => {},
  closeModal: () => {},
  activeModal: null,
  modalData: {}, // ✅ extra payload passed to the modal
});

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within ModalProvider');
  }
  return context;
};

export const ModalProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState(null);
  const [modalData, setModalData] = useState({}); // ✅ NEW

  const openModal = (modalName, data = {}) => {
    console.log('Opening modal:', modalName, data);
    setActiveModal(modalName);
    setModalData(data || {});
  };

  const closeModal = () => {
    console.log('Closing modal');
    setActiveModal(null);
    setModalData({});
  };

  const value = {
    activeModal,
    modalData, // ✅ exposed
    openModal,
    closeModal,
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
};